import ajaxRequest from 'utils/_ajax-request.js'

/**
 * @param {Dropzone} dropzone
 * @param {File} file
 * @param {HTMLInputElement} fileIdsElement
 */
let afterUploadToServer = (dropzone, file, fileIdsElement) =>
  /**
   * @param {XMLHttpRequest} xhr
   */
  (xhr) => {
    //console.log('dropzone afterUploadToServer')
    let response = JSON.parse(xhr.responseText)
    let value = JSON.parse(fileIdsElement.value || '[]') || []
    file.serverFileId = response.file_id
    if( file.previewElement.querySelector('.dz-file-checkbox') ) {
      file.previewElement.querySelector('.dz-file-checkbox').value = file.serverFileId
    }
    if( file.previewElement.querySelector('.dz-details') ) {
      file.previewElement.querySelector('.dz-details').setAttribute('href', response.file_src)
    }

    if( file.previewElement.querySelector('.dz-download-link') ) {
      file.previewElement.querySelector('.dz-download-link').setAttribute('href', response.file_src)

      if( file.previewElement.querySelector('.dz-details') ) {
        file.previewElement.querySelector('.dz-download-link').setAttribute('download', file.previewElement.querySelector('.dz-details').getAttribute('data-download'))
      }
    }

    /*let fileDate = '';
    if( file.createdAt ) {
      fileDate = convertDateCE(file.createdAt)
    }*/


    value.push(response.file_id)
    fileIdsElement.value = JSON.stringify(value)
  }

/**
 * @param {Dropzone} dropzone
 * @param {File} file
 * @param {HTMLInputElement} fileIdsElement
 */
let afterRemoveFromServer = (dropzone, file, fileIdsElement) =>
  /**
   * @param {XMLHttpRequest} xhr
   * @param {boolean} error
   */
  (xhr, error) => {
    if( error ) {
      return false
    }
    let response = JSON.parse(xhr.responseText)
    let value = JSON.parse(fileIdsElement.value || '[]') || []

    file.serverFileId = null
    fileIdsElement.value = JSON.stringify(value.filter((v) => {return v !== response.file_id}))
  }

/**
 * @param {Function} afterRemoveFromServer
 * @param {string} removeUrl
 */
let removeFromServer = (afterRemoveFromServer, removeUrl) =>
  /**
   * @param {int|string} fileId
   */
  (fileId) => {
    if( fileId ) {
      const formData = new FormData()
      formData.append('file_id', fileId.toString())
      ajaxRequest(afterRemoveFromServer, removeUrl, formData, 'POST')
    }
  }

/**
 * @param {string} filename
 */
let getExtension = (filename) => {
  let a = filename.split('.')
  if( a.length === 1 || ( a[0] === '' && a.length === 2 ) ) {
    return ''
  }
  return a.pop().toLowerCase()
}

export {
  afterUploadToServer,
  afterRemoveFromServer,
  removeFromServer,
  getExtension,
}
